<template>
  <div class="add-patient-page">
    <van-form label-width="4em" style="border-radius:10px;" @submit="onSubmit">
      <van-field
        v-if="!isEdit"
        readonly
        clickable
        name="picker"
        :value="gx"
        label="关系"
        placeholder="请选择关系"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="username"
        name="姓名"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        readonly
        clickable
        label="证件类型"
        :value="documentName"
        placeholder="选择证件类型"
        :disabled="isEdit"
        @click="showId = isEdit ? false : true"
      />
      <van-popup v-model="showId" round position="bottom">
        <van-picker
          show-toolbar
          :columns="columnsId"
          value-key="name"
          @cancel="showId = false"
          @confirm="onConfirmId"
        />
      </van-popup>
      <van-field
        v-model="idCard"
        name="证件号"
        label="证件号"
        placeholder="请输入证件号"
        maxlength="25"
        :disabled="isEdit"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="tel"
        name="手机号"
        label="手机号"
        maxlength="11"
        placeholder="请输入手机号"
      />
      <van-field
        v-if="showSmsField"
        v-model="smsCode"
        name="验证码"
        label="验证码"
        maxlength="6"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '' }]"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            plain
            :loading="smsSending"
            :disabled="smsCountdown > 0 || smsSending"
            native-type="button"
            :loading-text="smsSending ? '发送中...' : '获取验证码'"
            @click.stop="sendSmsCode"
          >
            {{ smsCountdown > 0 ? smsCountdown + 's后可获取' : '获取验证码' }}
          </van-button>
        </template>
      </van-field>
      <van-field
        v-if="!isHideAddress"
        v-model="address"
        is-link
        readonly
        label="住址"
        placeholder="请选择所在地区"
        @click="addressShow = true"
      />
      <van-popup v-model="addressShow" round position="bottom">
        <van-picker
          show-toolbar
          title="请选择现家庭住址"
          :columns="columnsAddress"
          value-key="address"
          :loading="addressLoading"
          @cancel="addressShow = false"
          @confirm="onConfirmAddress"
        >
          <template #columns-top>
            <van-search
              v-model="addressSearchValue"
              default
              show-action
              placeholder="请输入地址"
              @search="addressSearch"
            >
              <template #action>
                <div @click="addressSearchBtn">搜索</div>
              </template>
            </van-search>
          </template>
        </van-picker>
      </van-popup>
      <!-- <van-popup v-model="addressShow" round position="bottom">
        <van-cascader
          v-model="addressValue"
          title="请选择现家庭住址"
          :options="options"
          @close="addressShow = false"
          @finish="onFinish"
        />
      </van-popup> -->
      <div class="bottom">
        <p class="tips"><van-icon name="warning-o" style="color:#FCAA0C" />本院实行实名制就诊，请如实填写就诊人信息，如因信息错误产生的一切后果自行负责</p>
        <van-button round block type="info" native-type="submit" :loading="loading">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { list as addressList } from '@/assets/pcas-code.json'
export default {
  name: 'AddPatient',
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      addressLoading: false,
      columnsAddress: [],
      addressSearchValue: '',
      patientInfo: {},
      isEdit: false,
      options: addressList,
      address: '',
      addressValue: '',
      addressShow: false,
      id: '',
      isNotSelf: '',
      loading: false,
      showPicker: false,
      columns: [],
      columnsId: [
        { name: '身份证', id: '10' },
        { name: '港澳台居民通行证', id: '13' },
        { name: '永居证', id: '16' }
      ],
      showId: false,
      documentName: '身份证',
      documentType: '10',
      gx: '',
      username: '',
      idCard: '',
      tel: '',
      smsCode: '',
      smsCountdown: 0,
      smsTimer: null,
      smsSending: false,
      isHideAddress: '', // 是否隐藏地址
      showSmsField: true,
      originalTel: ''
    }
  },
  watch: {
    info: {
      handler(val) {
        if (val) {
          this.id = val.id
          this.isEdit = true
          this.username = val.patientName
          this.addressValue = val.addressCode || ''
          this.address = val.address || ''
          this.idCard = val.patientSfzh
          this.documentType = val.documentType
          this.documentName = val.documentName
          this.originalTel = val.patientPhone || ''
          this.tel = val.patientPhone
          this.showSmsField = false
        }
      },
      immediate: true
    },
    tel(val) {
      if (!this.isEdit) {
        this.showSmsField = true
        return
      }
      this.showSmsField = val !== this.originalTel
      if (!this.showSmsField) {
        this.smsCode = ''
      }
    }
  },
  created() {
    if (JSON.stringify(this.$route.query) === '{}') return
    const { id, isNotSelf, isHideAddress } = this.$route.query
    this.id = id
    this.isNotSelf = isNotSelf * 1
    this.isHideAddress = isHideAddress || ''
    this.gx = isNotSelf * 1 ? '本人' : '他人'
    this.columns = isNotSelf * 1 ? ['本人'] : ['他人']
  },
  mounted() {
    this.getAddress()
  },
  beforeDestroy() {
    this.clearSmsTimer()
  },
  methods: {
    onFinish({ selectedOptions }) {
      this.addressShow = false
      const value = selectedOptions.map((option) => option.text).join('/')
      this.address = value
    },
    onCancel() {},
    onSubmit() {
      if (this.isEdit) {
        this.editPatient()
      } else {
        this._addPatient()
      }
    },
    async _addPatient() {
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (this.documentType * 1 === 10 && !reg.test(this.idCard)) {
        this.$notify({ type: 'warning', message: '身份证格式不正确', duration: 1000 })
        return false
      }

      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.tel))) {
        this.$toast.fail('手机号码不合法，请重新输入')
        return false
      }

      if (!this.smsCode) {
        this.$notify({ type: 'warning', message: '请输入验证码', duration: 1000 })
        return false
      }

      this.loading = true
      const parms = {
        patient: {
          patientName: this.username,
          patientSfzh: this.idCard,
          documentName: this.documentName,
          documentType: this.documentType,
          patientPhone: this.tel,
          addressCode: this.addressValue,
          address: this.address
        }
      }
      if (this.isNotSelf) {
        parms.patient.appletsId = this.id
      } else {
        parms.id = this.id
      }
      try {
        await this.validateSmsCode()
        const res = await this.$Apis.addPatient(parms)
        if (res.code === 200) {
          this.$toast.success('添加成功')
          if (!localStorage.getItem('userInfo')) {
            await this.getByAppletsId(1)
            return
          }
          this.$router.go(-1)
        } else {
          this.$toast.fail(res.message)
        }
      } catch (error) {
        if (error && error.message) {
          this.$toast.fail(error.message)
        }
      } finally {
        this.loading = false
      }
    },
    async editPatient() {
      const parms = {
        id: this.id,
        patientName: this.username,
        documentName: this.documentName,
        documentType: this.documentType,
        addressCode: this.addressValue,
        address: this.address
      }
      const phoneChanged = this.info.patientPhone !== this.tel
      if (phoneChanged) {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.tel))) {
          this.$toast.fail('手机号码不合法，请重新输入')
          return false
        } else {
          parms.patientPhone = this.tel
        }
      }
      if (this.showSmsField && !this.smsCode) {
        this.$notify({ type: 'warning', message: '请输入验证码', duration: 1000 })
        return false
      }
      this.loading = true
      try {
        if (this.showSmsField) {
          await this.validateSmsCode()
        }
        const res = await this.$Apis.updPatient(parms)
        if (res.code === 200) {
          this.$toast.success('修改成功')
          if (this.info.appletsId) {
            this.getByAppletsId()
          }
          this.$emit('editSuccess')
        } else {
          this.$toast.fail(res.message || '修改失败')
        }
      } catch (error) {
        this.$toast.fail(error.message || '修改失败')
      } finally {
        this.loading = false
      }
    },
    getByAppletsId(off) {
      const appletsId = this.info?.appletsId ? this.info.appletsId : this.id
      return this.$Apis.getByAppletsId({ appletsId }).then(res => {
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          if (off) this.$router.go(-1)
        }
      })
    },
    getAddress(pinyin) {
      this.addressLoading = true
      this.$Apis.adAdministrativeRegionVoList({ pinyin }).then(res => {
        this.addressLoading = false
        if (res.code === 200) {
          this.columnsAddress = res.data
        } else {
          this.$toast(res.message)
          this.columnsAddress = []
        }
      }).catch(() => {
        this.columnsAddress = []
        this.addressLoading = false
      })
    },
    addressSearch(e) {
      this.getAddress(e)
    },
    addressSearchBtn() {
      this.getAddress(this.addressSearchValue)
    },
    onConfirmAddress(e) {
      this.address = e.address
      this.addressValue = e.addressCode
      this.addressShow = false
    },
    onConfirm(e) {
      this.gx = e
      this.showPicker = false
    },
    onConfirmId(e) {
      this.documentName = e.name
      this.documentType = e.id
      this.showId = false
    },
    async sendSmsCode() {
      if (this.smsCountdown > 0 || this.smsSending) return
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.tel))) {
        this.$notify({ type: 'warning', message: '请先输入正确的手机号', duration: 1000 })
        return
      }
      this.smsSending = true
      try {
        const res = await this.$Apis.sendSmsCode({
          phone: this.tel
        })
        if (res.code === 200) {
          this.$toast.success('验证码已发送')
          this.startSmsCountdown()
        } else {
          this.$toast.fail(res.message || '验证码发送失败')
        }
      } catch (error) {
        this.$toast.fail('验证码发送失败')
      } finally {
        this.smsSending = false
      }
    },
    startSmsCountdown() {
      this.smsCountdown = 60
      this.clearSmsTimer()
      this.smsTimer = setInterval(() => {
        if (this.smsCountdown <= 1) {
          this.clearSmsTimer()
          this.smsCountdown = 0
          return
        }
        this.smsCountdown -= 1
      }, 1000)
    },
    clearSmsTimer() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer)
        this.smsTimer = null
      }
    },
    async validateSmsCode() {
      const res = await this.$Apis.validateSmsCode({
        phone: this.tel,
        yzm: this.smsCode
      })
      if (res.code !== 200) {
        throw new Error(res.message || '验证码校验失败')
      }
      return true
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.add-patient-page {
  padding: 0.2rem;
  .tips{
    font-size: .14rem;
    margin-bottom: 20px;
    line-height: 1.5;
    color: #999;
  }

  .bottom{
    position: fixed;
    bottom: .4rem;
    left: .2rem;
    width: calc(100% - .4rem);
  }
}
</style>
